/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import axios from "axios";
import ReactGA from "react-ga";
import { env } from "~/utils";

let gUserId: string;
let gPdfName: string;

const init = (pdfName: string, userId?: string): void => {
  ReactGA.initialize(env.getGATrackingCode());
  gPdfName = pdfName;

  if (!userId) return;

  gUserId = userId;

  const reportData = { openedCTAAt: Date.now() };
  const ENDPOINT =
    "https://buipy8nnm5.execute-api.eu-central-1.amazonaws.com/dev/recipents";
  axios
    .put(`${ENDPOINT}/${userId}`, JSON.stringify(reportData))
    .catch((err) => console.log("err", err));
};

const pageView = (pageNum: number): void => {
  ReactGA.pageview(`${gPdfName} - ${pageNum}`);

  if (!gUserId) return;

  const reportData = { seenPages: pageNum };
  const ENDPOINT =
    "https://buipy8nnm5.execute-api.eu-central-1.amazonaws.com/dev/recipents";
  axios
    .put(`${ENDPOINT}/${gUserId}`, JSON.stringify(reportData))
    .catch((err) => console.log("err", err));
};

const pageRender = (pageNum: number, time: number): void => {
  if (!gUserId) return;

  const reportData = { renderedPages: { num: pageNum, time } };
  const ENDPOINT =
    "https://buipy8nnm5.execute-api.eu-central-1.amazonaws.com/dev/recipents";
  axios
    .put(`${ENDPOINT}/${gUserId}`, JSON.stringify(reportData))
    .catch((err) => console.log("err", err));
};

export default { init, pageView, pageRender };
